/**
 * Iter154: Wandelt eine FastAPI/Pydantic-Error-Response in einen lesbaren String.
 *
 * FastAPI 422-Antworten enthalten `detail` als ARRAY von Objekten:
 *   [{type, loc, msg, input, ctx, url}, ...]
 *
 * Diese direkt in JSX (z.B. via toast.error(...)) zu rendern, wirft:
 *   "Objects are not valid as a React child"
 *
 * Diese Helper-Funktion:
 *   - Gibt Strings unverändert zurück
 *   - Extrahiert `msg` aus jedem Element eines Arrays und joined mit Komma
 *   - Fällt auf `fallback` zurück wenn nichts sinnvoll extrahierbar
 */
export function extractErrorMessage(err, fallback = "Ein unerwarteter Fehler ist aufgetreten.") {
  const detail = err?.response?.data?.detail ?? err?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object") {
          const loc = Array.isArray(d.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
          return loc ? `${loc}: ${d.msg || "Validierungsfehler"}` : (d.msg || "");
        }
        return "";
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join(" · ");
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (err?.message && typeof err.message === "string") return err.message;
  return fallback;
}
